import React, { useEffect, useState } from "react";
import dsc from "../images/dsc.png";
import { dscChecker, registryEntry, validateDSC } from "../api/User";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import loader from "../images/ajax-loader.gif";
import "./Admin/ProfilePage.css";

const DigitalCertificateComponent = ({
  Type,
  modal,
  close,
  token,
  userDetail,
  userData,
  show,
  loadingFunction
}) => {
  const [showProceedButton, setShowProceedButton] = useState(false);
  const [isBlinking, setIsBlinking] = useState(true);
  const MySwal = withReactContent(Swal);
  const [registryData, setRegistryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingNew, setLoadingNew] = useState(false);

  useEffect(() => {
    getRegistryEntity();
  }, []);

  const handleValidateClick = () => {
    handleDSCinsert();
  };

  const handleProceedClick = () => {
    if (Type === "VenderPaymentCreation") {
      close();
      modal();
    } else if (Type === "VenderRegistrationMaker") {
      show();
    } else if (Type === "VenderPaymentRelease") {
      close();
      loadingFunction();
    } else if (Type === "VenderPaymentCreationReceivable") {
      close();
    } else if (Type === "VenderApproval") {
      modal();
      close();
    }
  };

  const handleDSCinsert = async () => {
    setLoadingNew(true);
    fetch(
      `http://127.0.0.1:9196/isDscPresent/${userData?.data?.user_firstname}`,
      {
        method: "GET",
      }
    )
      .then((response) => {
        if (!response.ok) {
          setLoadingNew(false);
                MySwal.fire({
                  icon: "warning",
                  title: "Invalid DSC",
                  text: "Please Attach DSC.",
                });
          throw new Error(`HTTP error! status: ${response.status}`);
          
        }
        return response.text();
      })
      .then((data) => {
        console.log("data1", data);
        if (data == "DSC is valid") {
          fetch(
            `http://127.0.0.1:9196/dscauth/${userData?.data?.user_firstname}`,
            {
              method: "GET",
            }
          )
            .then((res) => {
              if (!res.ok) {
                MySwal.fire({
                  icon: "warning",
                  title: "Invalid DSC",
                  text: "Please Attach Valid DSC.",
                });
                throw new Error(`HTTP error! status: ${res.status}`);
              }
              return res.text();
            })
            .then((data2) => {
              if (data2 == "DSC is valid") {
                setShowProceedButton(true);
                setLoadingNew(false);
                MySwal.fire({
                  icon: "success",
                  title: "DSC Validated",
                  text: "DSC Validated Successfully!",
                });              } else {
                setLoadingNew(false);
                MySwal.fire({
                  icon: "warning",
                  title: "Invalid DSC",
                  text: "Please Attach Valid DSC.",
                });
              }
            })
            .catch((error) => {
              setLoadingNew(false);
              console.error("Error:", error);
              MySwal.fire({
                icon: "error",
                title: "Error",
                text:
                  error.message === "Failed to upload voucher"
                    ? "Failed to upload voucher."
                    : "Please Start Java Utility",
              });
            });
        } else {
          setLoadingNew(false);
          MySwal.fire({
            icon: "warning",
            title: "Invalid DSC",
            text: "Please Attach valid DSC.",
          });
        }
      })
      .catch((error) => {
        setLoadingNew(false);
        MySwal.fire({
          icon: "warning",
          title: "Invalid DSC",
          text: "Please Attach Valid DSC.",
        });
        console.error("Error:", error);
      });
  };

  const getRegistryEntity = async () => {
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
    };
    try {
      const res = await registryEntry(token, data);
      if (res.status == "success") {
        setRegistryData(res.data);
      } else {
        console.log("Error Occured");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container-fluid col px-2 px-md-4 ">
      <div id="loading-coupon" style={{ display: loading ? "block" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div
        id="loading-coupon3"
        style={{ display: loadingNew ? "flex" : "none" }}
      >
        <img id="loading-image2" src={loader} alt="Loading..." />
      </div>
      <div className="my-5 col-12 d-flex justify-content-between align-items-center">
        <h5>
          <strong>Digital Certificate Authentication</strong>
        </h5>
      </div>
      <div className="d-flex mb-1">
        <div>
          <img
            src={dsc}
            alt="USB Token"
            className="me-3"
            style={{ height: "22vh" }}
          />
        </div>
        <div className="d-flex flex-column justify-content-center">
          <p style={{ position: "relative" }}>
            <span
              className={`${isBlinking ? "blink" : ""}`}
              style={{
                background: "#e64b4b",
                padding: "0.2em",
                color: "#fff",
                fontSize: "22px",
              }}
            >
              You have registered with DSC. Please insert your DSC card /
              e-Token for Authentication. Click the 'Validate' button to
              Proceed.
            </span>
          </p>
        </div>
      </div>
      <div className="d-flex justify-content-center mb-2">
        <button type="button" className="btn" onClick={handleValidateClick}>
          Validate
        </button>
      </div>
      <div>
        <table className="table table-bordered" aria-label="simple table">
          <thead>
            <tr>
              <th align="center" style={{ backgroundColor: "#f2f2f2" }}>
                S.No
              </th>
              <th align="center" style={{ backgroundColor: "#f2f2f2" }}>
                Alias Name
              </th>
              <th align="center" style={{ backgroundColor: "#f2f2f2" }}>
                Serial Number
              </th>
              <th align="center" style={{ backgroundColor: "#f2f2f2" }}>
                Certificate Type
              </th>
              <th align="center" style={{ backgroundColor: "#f2f2f2" }}>
                Expiry Date
              </th>
              <th align="center" style={{ backgroundColor: "#f2f2f2" }}>
                Status
              </th>
            </tr>
          </thead>
          {registryData?.map((data, index) => (
            <tbody key={index}>
              <tr>
                <td className="textc">{index + 1}</td>
                <td className="textc">{data.name}</td>
                <td className="textc">{data.serial_no}</td>
                <td className="textc">Signing</td>
                <td className="textc">{data.expiry_date}</td>
                <td className="textc">Live</td>
              </tr>
            </tbody>
          ))}
        </table>
        {showProceedButton && (
          <div className="d-flex justify-content-center">
            <button type="button" className="btn" onClick={handleProceedClick}>
              Proceed
            </button>
          </div>
        )}
      </div>
      <div className="mt-4">
        <p>
          <strong>
            If "Proceed" button is not appearing in this screen, perform the
            following checks:
          </strong>
        </p>
        <ol className="list-decimal list-inside text-muted-foreground">
          <li>
            Java Runtime Environment (JRE) 1.8 or above should be installed.
          </li>
          <li>DSC driver should be installed from the resource CD.</li>
          <li>
            The DSC smart card / e-Token must be plugged in with the system's
            USB/smart card reader.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default DigitalCertificateComponent;
